import { useState } from "react";
import { useDispatch } from "react-redux";

import { LabOrder } from "pwapi";

import { completeLabOrder } from "shared/actions/labOrdersActions";
import Menu from "shared/components/Menu";

import { PathologyWatchButton } from "components/customInputs/buttons/Button";

import PopUpDialog from "../PopUpDialog";

const OrderCompletionButton = ({ order }: { order: LabOrder }) => {
  const dispatch = useDispatch();

  const [isWarningOpen, setIsWarningOpen] = useState<boolean>(false);

  const onHandleConfirm = () => {
    order.id &&
      dispatch(completeLabOrder(order.id)).then(() => setIsWarningOpen(false));
  };

  return (
    <>
      {isWarningOpen && (
        <PopUpDialog
          onClose={() => setIsWarningOpen(false)}
          portalToBody={true}
          title="Complete this order"
          type="warning"
        >
          <div className="CaseWarningDialog">
            <p>Complete this lab order?</p>
            <div className="actions__container">
              <PathologyWatchButton onClick={() => setIsWarningOpen(false)}>
                Cancel
              </PathologyWatchButton>
              <PathologyWatchButton
                type="submit"
                color="red"
                testId="order_confirm_complete"
                onClick={() => onHandleConfirm()}
              >
                Confirm
              </PathologyWatchButton>
            </div>
          </div>
        </PopUpDialog>
      )}
      <Menu.Item icon="check" onClick={() => setIsWarningOpen(true)}>
        Complete Order
      </Menu.Item>
    </>
  );
};

export default OrderCompletionButton;
